import {DossierT10, DossierT2000} from "./base.model";

export class DictType {
  code?: DossierT10 = '';
  name?: DossierT2000 = '';
}
